<template>
  <!-- <DBox
    :id="'cmp-settings-users-users_list'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('User')}`"
    @add_click="onAddClick"
  > -->

  <div class="settings-users-users_list">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        class="user-list-table h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr :title="item.fullname">
            <td @click="onUserItemClick(item)" v-bind="tdcon('users')">
              <span> {{ item["user_name"] }} </span>
            </td>
            <td v-bind="tdcon('fullname')">
              <!-- <input
                type="text"
                class="dbox-table--textfield"
                name="staff_fullname"
                :id="item.user_id + 'staff_fullname'"
                :value="item['staff_fullname']"
                v-on:blur="(e) => onTextInputBlur(e, 'staff_fullname', item)"
              /> -->
              <TextField2
                :id="'staff_fullname'"
                :showLabel="false"
                :value="item['staff_fullname']"
                @blur="(e) => onTextInputBlur(e, item)"
                :bb="'0px'"
              />
            </td>
            <td v-bind="tdcon('phone1')">
              <!-- <input
                type="text"
                class="dbox-table--textfield"
                name="staff_phone1"
                :id="item.user_id + 'staff_phone1'"
                :value="item['staff_phone1']"
                v-on:blur="(e) => onTextInputBlur(e, 'staff_phone1', item)"
              /> -->
              <TextField2
                :showLabel="false"
                :id="'staff_phone1'"
                :value="item['staff_phone1']"
                @blur="(e) => onTextInputBlur(e, item)"
                :bb="'0px'"
              />
            </td>
            <td v-bind="tdcon('phone2')">
              <!-- <input
                type="text"
                class="dbox-table--textfield"
                name="staff_phone2"
                :id="item.user_id + 'staff_phone2'"
                :value="item['staff_phone2']"
                v-on:blur="(e) => onTextInputBlur(e, 'staff_phone2', item)"
              /> -->
              <TextField2
                :showLabel="false"
                :id="'staff_phone2'"
                :value="item['staff_phone2']"
                :bb="'0px'"
                @blur="(e) => onTextInputBlur(e, item)"
              />
            </td>
            <td v-bind="tdcon('email_1')">
              <!-- <input
                type="text"
                class="dbox-table--textfield"
                name="staff_email"
                :id="item.user_id + 'staff_email'"
                :value="item['staff_email']"
                v-on:blur="(e) => onTextInputBlur(e, 'staff_email', item)"
              /> -->
              <TextField2
                :showLabel="false"
                :id="'staff_email'"
                :value="item['staff_email']"
                @blur="(e) => onTextInputBlur(e, item)"
                :bb="'0px'"
              />
            </td>
            <td v-bind="tdcon('cost')">
              <span>€{{ $dft.curr(item["user_cost"]) }} </span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                @click.stop="(e) => onUserDelete(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1 ut-center"
                :alt="$t('delete_user')"
                :title="$t('delete_user')"
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </div>
  <!-- </DBox> -->
</template>
  
  <script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";

export default {
  components: {
    NTable,
    DBox,
  },
  props: {
    loadingFlag: {
      type: Boolean,
      default: false,
    },
    userList: {
      type: Object,
      default: () => [],
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        fullHeight: true,
        footer: false,
        rowHeight: 40,
      }),
    };
  },
  computed: {
    headers: () => [
      createTableHeader("users", { text: "username" }),
      createTableHeader("fullname"),
      createTableHeader("phone1"),
      createTableHeader("phone2"),
      createTableHeader("email_1"),
      createTableHeader("cost", { ta: "right" }),
      createTableHeader("options", { text: false, mw: 50 }),
    ],
    list: function () {
      return this.$store?.getters?.account?.user?.user_name == "details_helper"
        ? this.userList.all_user
        : this.userList.all_user.filter((e) => e.user_name != "details_helper");
    },
  },
  methods: {
    onUserItemClick: function (item) {
      this.$emit("onUserItemClick", item);
    },
    onAddClick: function () {
      this.$emit("add_click", "create_user");
    },
    onUserDelete: function (item) {
      this.$emit("onUserDelete", item);
    },

    onTextInputBlur: function (e, item) {
      this.$emit("onTextInputBlur", {
        name: e.name,
        value: e.value,
        item: item,
      });
    },
    onDeleteTaxType: function (item) {
      this.$emit("delete_click", item);
    },
    onTaxTypeEdit: function (item) {
      this.$emit("edit_click", item);
    },
    onTaxTypeDragstart: function (event, item) {
      if (!item) {
        return;
      }
      event.dataTransfer.setData("text", JSON.stringify(item));
    },
    onTaxDeductionFlagChange: function (event, name, item) {
      const value = event.target.checked ? "1" : "0";
      this.$emit("changed", { name, value, item });
    },
    descriptionText(item) {
      return `${item["tax_description"]}`;
    },
    // MARK: Methods
  },
};
</script>
<style lang="scss">
.cmp-settings-users-users_list {
  .settings-users-users_list {
    //overflow: hidden;
    // .dt-ntable {
    //   --ntable-height: none !important;
    // }
  }
}
</style>